function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function isRemoteLoading() {
  const appCookie = getCookie('app');

  return window.self !== window.top && appCookie === 'instore';
}

// True only when this app runs inside a CROSS-SITE iframe (Wix/Shopify/...
// provider dashboards). The nested same-origin iframe of the React host must
// stay false: there the cookie works and a retained Bearer would go stale on
// impersonation/user switches.
// Not interchangeable with utils/providerIframe#insideProviderIframe: that one
// matches ancestorOrigins (empty on Firefox/Safari) against known provider
// domains and is true for the same-origin host nesting — use THIS predicate
// for the cross-site auth boundary.
function isCrossSiteEmbed() {
  if (window.self === window.top) {
    return false;
  }
  try {
    // Reading a cross-origin ancestor's location throws a SecurityError,
    // which is itself the "foreign parent" signal (works on Firefox/Safari,
    // unlike ancestorOrigins).
    return !window.top || window.top.location.origin !== window.location.origin;
  } catch (error) {
    return true;
  }
}

export { isRemoteLoading, isCrossSiteEmbed };
export default isRemoteLoading;
